import { ErrorResponse } from '@src/interface/api/response.interface'
import { checkAuth, AuthCheckResponse } from '@src/lib/api/auth/checkAuth'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useCheckAuthQuery = (): UseQueryResult<AuthCheckResponse, AxiosError<ErrorResponse>> => {
	return useQuery(
		['authCheck'],
		() => {
			return checkAuth()
		},
		{ enabled: false, retry: false },
	)
}
export default useCheckAuthQuery
